import moment from 'moment'

import { EUROPEAN_DATE, EUROPEAN_DATE_WITH_HOURS_AND_MINUTES } from '../constants'
import { getTimezoneLessMoment } from '../momentjs'

/** @enum {string} */
export const Statuses = Object.freeze({
  OPEN: 'OPEN',
  HANDLED: 'HANDLED',
  IGNORED: 'IGNORED'
})

/** @enum {string} */
export const Severities = Object.freeze({
  CRITICAL: 'CRITICAL',
  WARNING: 'WARNING'
})

/** @enum {string} */
export const Types = Object.freeze({
  DUPLICATED_APHM_ID: 'DUPLICATED_APHM_ID',
  OVERLAPPING_INTERNSHIP: 'OVERLAPPING_INTERNSHIP',
  DUPLICATED_APHM_LINK: 'DUPLICATED_APHM_LINK',
  DELETION_WITH_SHIFTS: 'DELETION_WITH_SHIFTS',
  DELETION_OF_ACCEPTED: 'DELETION_OF_ACCEPTED',
  ABNORMAL_DELETION_VOLUME: 'ABNORMAL_DELETION_VOLUME',
  ABNORMAL_CREATION_VOLUME: 'ABNORMAL_CREATION_VOLUME',
  DELETED_INTERNSHIP_STILL_SENT: 'DELETED_INTERNSHIP_STILL_SENT'
})

const UNKNOWN_TAG = Object.freeze({ label: 'aphm_anomaly.unknown', color: 'gray' })

export const SeverityTags = Object.freeze({
  [Severities.CRITICAL]: { label: 'aphm_anomaly.severity.critical', color: 'red' },
  [Severities.WARNING]: { label: 'aphm_anomaly.severity.warning', color: 'orange' }
})

export const StatusTags = Object.freeze({
  [Statuses.OPEN]: { label: 'aphm_anomaly.status.open', color: 'blue' },
  [Statuses.HANDLED]: { label: 'aphm_anomaly.status.handled', color: 'green' },
  [Statuses.IGNORED]: { label: 'aphm_anomaly.status.ignored', color: 'gray' }
})

export const getSeverityTag = severity => SeverityTags[severity] ?? UNKNOWN_TAG

export const getStatusTag = status => StatusTags[status] ?? UNKNOWN_TAG

export const getTypeLabel = type => 'aphm_anomaly.type.' + String(type ?? 'unknown').toLowerCase()

export const formatDate = date => date ? getTimezoneLessMoment(date).format(EUROPEAN_DATE) : null

export const formatStampDate = date => date ? moment(date).format(EUROPEAN_DATE) : null

export const formatStampDateTime = date => date ? moment(date).format(EUROPEAN_DATE_WITH_HOURS_AND_MINUTES) : null

export const VOLUME_TYPES = [Types.ABNORMAL_DELETION_VOLUME, Types.ABNORMAL_CREATION_VOLUME]

export const isVolume = anomaly => VOLUME_TYPES.includes(anomaly?.type)

export const getOpenCount = summary => summary?.byStatus?.[Statuses.OPEN] ?? 0

export const getLastDetectedAt = summary => summary?.lastDetectedAt ?? null

export const hasUnseenAnomalies = (summary, seenUntil) => {
  if (getOpenCount(summary) === 0) {
    return false
  }

  const lastDetectedAt = getLastDetectedAt(summary)

  if (!seenUntil || !lastDetectedAt) {
    return true
  }

  return moment(lastDetectedAt).isAfter(seenUntil)
}
